class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (!overlay) {
        console.warn('[Cart Drawer Manipulations] #CartDrawer-Overlay not found');
      } else {
        overlay.addEventListener('click', this.close.bind(this));
      }
      
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
  
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
   // (Dawn-kompatibel mit [open])
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
  
    // Setze Open-Attribut für CSS & A11y
    this.setAttribute('open', '');
    // Animation klassisch per Klasse (ok), aber Sichtbarkeit läuft über [open]
    requestAnimationFrame(() => this.classList.add('animate', 'active'));
  
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
  
    document.body.classList.add('overflow-hidden');
  }
  
  close() {
    this.classList.remove('active');
    this.removeAttribute('open'); // <- wichtig
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
  
        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
  
      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (!overlay) {
          console.warn('[Cart Drawer Manipulations] #CartDrawer-Overlay not found in renderContents');
        } else {
          overlay.addEventListener('click', this.close.bind(this));
        }
        this.open();
      });
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);

  // Smart Cart Drawer Auto-Open with Toast Notification
  // Best Practice: Wartet auf renderContents() bevor Drawer öffnet → keine visuellen Sprünge
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    let pendingOpen = false;

    // Hook in renderContents() to know when cart is fully updated
    const originalRender = cartDrawer.renderContents;
    if (originalRender) {
      cartDrawer.renderContents = function(parsedState) {
        originalRender.call(this, parsedState);
        
        // Dispatch custom event when rendering is complete
        this.dispatchEvent(new CustomEvent('cart-drawer:rendered', {
          detail: { state: parsedState },
          bubbles: true
        }));
        
        // If there's a pending open, execute it now
        if (pendingOpen) {
          pendingOpen = false;
          this.open();
        }
      };
    }

    // Listen to cart:updated event (Dawn standard)
    document.addEventListener('cart:updated', () => {
      pendingOpen = true;
      showToast('✓ Zum Warenkorb hinzugefügt', 1000);
    });

    // Fallback: Form submit detection
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', () => {
        pendingOpen = true;
        showToast('✓ Zum Warenkorb hinzugefügt', 1000);
      });
    });
  });

  // Toast Notification Helper
  function showToast(message, duration = 1000) {
    const toast = document.createElement('div');
    toast.className = 'edm-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => toast.classList.add('show'), 10);
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }

